import React from "react";
import { useGetAssignmentMarksQuery } from "../../../features/assignmentMark/assignmentMarkApi";
import AssignmentMark from "./AssignmentMark";

const AssignmentMarks = () => {
  const {
    data: assignmentMarks,
    isError,
    isLoading,
  } = useGetAssignmentMarksQuery();

  const pendingMarks = assignmentMarks?.filter(
    (assignmentMark) => assignmentMark?.status === "pending"
  );

  const publishedMarks = assignmentMarks?.filter(
    (assignmentMark) => assignmentMark?.status === "published"
  );

  // decide what to show based on the state
  let content = null;
  if (isLoading) {
    content = <div>Loading...</div>;
  }
  if (!isLoading && isError) {
    content = <div>Something went wrong...</div>;
  }
  if (!isLoading && !isError && assignmentMarks.length > 0) {
    content = assignmentMarks.map((assignmentMark) => (
      <AssignmentMark key={assignmentMark.id} assignmentMark={assignmentMark} />
    ));
  }

  return (
    <div className="mx-auto max-w-full px-5 lg:px-20">
      <div className="px-3 py-20 bg-opacity-10">
        <ul className="assignment-status">
          <li>
            Total <span>{assignmentMarks?.length}</span>
          </li>
          <li>
            Pending <span>{pendingMarks?.length}</span>
          </li>
          <li>
            Mark Sent <span>{publishedMarks?.length}</span>
          </li>
        </ul>
        <div className="overflow-x-auto mt-4">
          <table className="divide-y-1 text-base divide-gray-600 w-full">
            <thead>
              <tr>
                <th className="table-th">Assignment</th>
                <th className="table-th">Date</th>
                <th className="table-th">Student Name</th>
                <th className="table-th">Repo Link</th>
                <th className="table-th">Mark</th>
              </tr>
            </thead>

            <tbody className="divide-y divide-slate-600/50">{content}</tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default AssignmentMarks;
